module.exports = __webpack_public_path__ + "img/arrow-download.b0b3c8b0.svg";